// Get Effective Interest Rate
export const getEffectiveInterestRate = (
    periods: number | undefined,
    payment: number | undefined,
    present: number | undefined,
    future?: number,
    type?: number,
    guess?: number,
): number | undefined => {
    future = future === undefined ? 0 : future;
    type = type === undefined ? 0 : type;
    guess = guess === undefined ? 0.01 : guess;

    if (periods && payment && present) {
        const pay: number = -payment;

        // Set maximum epsilon for end of iteration
        const epsMax = 1e-10;

        // Set maximum number of iterations
        const iterMax = 10;

        // Implement Newton's method
        let y: number;
        let y0: number;
        let y1: number;
        let x0: number;
        let x1: number;
        let f = 0;
        let i: number;

        let rate = guess;

        if (Math.abs(rate) < epsMax) {
            y = present * (1 + periods * rate) + pay * (1 + rate * type) * periods + future;
        } else {
            f = Math.exp(periods * Math.log(1 + rate));
            y = present * f + pay * (1 / rate + type) * (f - 1) + future;
        }
        y0 = present + pay * periods + future;
        y1 = present * f + pay * (1 / rate + type) * (f - 1) + future;
        i = 0;
        x0 = 0;
        x1 = rate;
        while (Math.abs(y0 - y1) > epsMax && i < iterMax) {
            rate = (y1 * x0 - y0 * x1) / (y1 - y0);
            x0 = x1;
            x1 = rate;
            if (Math.abs(rate) < epsMax) {
                y = present * (1 + periods * rate) + pay * (1 + rate * type) * periods + future;
            } else {
                f = Math.exp(periods * Math.log(1 + rate));
                y = present * f + pay * (1 / rate + type) * (f - 1) + future;
            }
            y0 = y1;
            y1 = y;
            i += 1;
        }
        return ((1 + rate) ** 12 - 1) * 100;
    }
    return undefined;
};

export default { getEffectiveInterestRate };
